var _rect, _g, _defs;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgQuality(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    rx: 18,
    fill: "url(#paint0_linear_7_57200)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7_57200)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M13 13.325V17.2417C13 20.575 15.125 23.6583 18 24.6C20.875 23.6583 23 20.5833 23 17.2417V13.325L18 11.45L13 13.325Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.0002 9.66669L11.3335 12.1667V17.2417C11.3335 21.45 14.1752 25.375 18.0002 26.3334C21.8252 25.375 24.6668 21.45 24.6668 17.2417V12.1667L18.0002 9.66669ZM23.0002 17.2417C23.0002 20.575 20.8752 23.6584 18.0002 24.6C15.1252 23.6584 13.0002 20.5834 13.0002 17.2417V13.325L18.0002 11.45L23.0002 13.325V17.2417Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_7_57200",
    x1: 25.5,
    y1: 58,
    x2: 15.5455,
    y2: -11.4545,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#29B6F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.229167,
    stopColor: "#4FC3F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.583333,
    stopColor: "#81D4FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.833333,
    stopColor: "#B3E5FC"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7_57200"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(8 8)"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuality);
export default __webpack_public_path__ + "static/media/quality.7bce00344994736c7c802d73aa367615.svg";
export { ForwardRef as ReactComponent };